export default __webpack_public_path__ + "static/char-s-15-cht-391c0b4df39c7f27da92178b0105a2c0.png";